import request from '../request';
import { url } from './config';
import { UserPreferences } from './types';

const handleData = (res: any) => res.data;

class UserPreferencesApi {
    /** `forUserId`: see update(). A mismatch fails the load, so nothing is shown or saved as the wrong user. */
    get(forUserId?: string | null): Promise<UserPreferences> {
        return request.get(url, forUserId ? { params: { userId: forUserId } } : undefined).then(handleData);
    }

    /**
     * `forUserId` is the user these preferences were loaded for. The server
     * refuses the write if the session now belongs to someone else — another
     * tab signed in as a different user — instead of storing one user's
     * layouts on the other's row.
     */
    update(preferences: Partial<UserPreferences>, forUserId?: string | null): Promise<UserPreferences> {
        return request
            .put(url, preferences, forUserId ? { params: { userId: forUserId } } : undefined)
            .then(handleData);
    }
}

export default new UserPreferencesApi();
